import React from 'react';

const NotFoundPage = () => (
    <>
        <h1> 404: Page not found.    </h1>
    </>
)


export default NotFoundPage;